import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '640px',
    emptyText: '暂无数据',
    menu: false,
    column: [{
      label: '问卷标题',
      prop: 'title',
      search: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    // {
    //   label: '类型',
    //   prop: 'type',
    //   search: true,
    //   searchSlot: true,
    //   addDisplay: false,
    //   editDisplay: false,
    //   viewDisplay: true,
    //   editDisabled: false,
    //   overHidden: true,
    //   align: 'center',
    //   formatter: function (row, value) {
    //     return value == 1 ? '实名' : value == 2 ? '匿名' : value == 3 ? '全部' : '暂无'
    //   }
    // },
    {
      label: "类型",
      prop: "type",
      search: true,
      type: "select",
      dicData: [
        {
          label: "实名",
          value: 1
        },
        {
          label: "匿名",
          value: 2
        }
      ],
      formatter: function (row, value) {
        if (Number(value) === 1) {
          return "实名";
        } else if (Number(value) === 2) {
          return "匿名";
        }
        return "";
      }
    },
    // {
    //   label: '状态',
    //   prop: 'status',
    //   searchSlot: true,
    //   search: true,
    //   addDisplay: false,
    //   editDisplay: false,
    //   viewDisplay: true,
    //   editDisabled: false,
    //   overHidden: true,
    //   align: 'center',
    //   formatter: function (row, value) {
    //     return value == 1 ? '未发布' : value == 2 ? '已发布' : '暂无'
    //   }
    // },
    {
      label: "状态",
      prop: "status",
      search: true,
      type: "select",
      dicData: [
        {
          label: "未发布",
          value: 1
        },
        {
          label: "已发布",
          value: 2
        }
      ],
      formatter: function (row, value) {
        if (Number(value) === 1) {
          return "未发布";
        } else if (Number(value) === 2) {
          return "已发布";
        }
        return "";
      }
    },
    {
      label: '创建时间',
      prop: 'createTime',
      search: false,
      overHidden: true,
      addDisplay: false,
      editDisplay: false,
      type: 'datetimerange',
      viewDisplay: false,
      align: 'right',
      hide: false,
      span: 24,
      formatter: function (row, value) {
        return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
      }
    },
    {
      label: '创建人',
      prop: 'creator',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      hide: false,
      align: 'center',
    },
    {
      label: '截止时间',
      prop: 'cutOffTime',
      search: false,
      overHidden: true,
      addDisplay: false,
      editDisplay: false,
      type: 'datetimerange',
      viewDisplay: false,
      align: 'right',
      hide: false,
      span: 24,
      formatter: function (row, value) {
        return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
      }
    },
    {
      label: '二维码',
      prop: 'twoDimensionCode',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      formslot: true,
      viewslot: true,
      align: 'center',
    }
    ],
  }
}